import React, { forwardRef } from "react";
// import PropTypes from "prop-types";
import styled from "styled-components";

/* Component shadowing */
import { Navigation as SitesparkNavigation } from "@racepointenergy/gatsby-theme-sitespark/src/components/Navigation/index";
import {
  navLinkStyles,
  StyledLink as NavLink,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Navigation/shared";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import { Link } from "components/CallToAction";
import SavantPowerLogo from "images/savantPowerLogo.png";

const CtaNavLink = styled(Link)`
  ${navLinkStyles}
  && {
    background-color: transparent;
    border-width: 1px;
    font-size: inherit;
  }
  @media screen and (max-width: 959px) {
    padding: 21px 23px;
  }
  @media screen and (min-width: ${getSize("tablet960")}) {
    padding: 11px 21px;
  }
`;

export const Navigation = forwardRef((props, navRef) => (
  <SitesparkNavigation
    logo={{ image: SavantPowerLogo, alt: "Racepoint Logo" }}
    links={[
      <NavLink to="/how-it-works">How It Works</NavLink>,
      <NavLink to="/applications">Applications</NavLink>,
      <NavLink to="/utilities">Utilities</NavLink>,
      <NavLink to="/become-a-savant-power-dealer">Pro</NavLink>,
      <CtaNavLink to="/get-a-preliminary-proposal">
        Get a Preliminary Proposal
      </CtaNavLink>,
    ]}
    ref={navRef}
  />
));

Navigation.propTypes = {};
